class LifestyleView {

    constructor(onSelectionChangedFn,
                onMinutesSelectionChangedFn,
                onDaySelectionChangedFn) {

        this.onSelectionChangedFn = onSelectionChangedFn;
        this.onMinutesSelectionChangedFn = onMinutesSelectionChangedFn;
        this.onDaySelectionChangedFn = onDaySelectionChangedFn;

        this.rootNode = $('.module--lifestyle');
        this.activitySelect = this.rootNode.find('.activity-select');
        this.activitySelect.change(this.onSelectActivity.bind(this));
        let thisObj = this;
        this.activityViews = this.rootNode.find('.activity-block').map(function (i, node) {
            return new LifestyleActivityView(thisObj, $(node), i + 1);
        });
    }

    onSelectActivity() {
        let selectedActivityNo = parseInt(this.activitySelect.val());
        if (selectedActivityNo > 0) {
            this.activityViews[selectedActivityNo - 1].select();
        }
    }
}

class LifestyleActivityView {

    constructor(parent, node, activityNo) {
        this.parent = parent;
        this.node = node;
        this.activityNo = activityNo;
        this.node.hide().removeClass('hidden');
        this.close = this.node.find('.icon-close');
        this.close.click(this.onClose.bind(this));
        this.dayTimeSelector = new DayAndMinutesSelector(
            this.node,
            this.onMinutesSelectionChanged.bind(this),
            this.onDaySelectionChanged.bind(this));
    }

    onMinutesSelectionChanged(minutesInput) {
        this.parent.onMinutesSelectionChangedFn(this.activityNo-1, minutesInput);
    }

    onDaySelectionChanged(days) {
        this.parent.onDaySelectionChangedFn(this.activityNo-1, days);
    }

    update(isSelected, duration, days) {
        if(isSelected) {
            this.select(false);
        } else {
            this.onClose(false);
        }
        this.dayTimeSelector.updateSelected(duration, days);
    }

    select(animated) {
        animated = trueIfUndefined(animated);
        if(animated) {
            this.node.parent().append(this.node);
            this.node.slideDown();
        } else {
            this.node.show();
        }
        this.parent.activitySelect.find('option[value="' + this.activityNo + '"]').hide();
        this.parent.activitySelect.val(0);
        this.parent.onSelectionChangedFn(this.activityNo-1, true);
    }

    onClose(animated) {
        animated = trueIfUndefined(animated);
        if(animated) {
            this.node.slideUp(() => this.node.hide());
        } else {
            this.node.hide();
        }
        this.parent.activitySelect.find('option[value="' + this.activityNo + '"]').show();
        this.parent.onSelectionChangedFn(this.activityNo-1, false);
    };
}
